import {
  gaqlenumCHAIN as CHAIN,
  gaqlenumARGSIG as ARGSIG,
  gaqlenumQueryNameBRACKET as BRACKET
} from './gaqlenum.js'

import {
  gaqlchainIs as chainIs,
  gaqlchainIsShallow as chainIsShallow,
  gaqlchainRecsGet as chainRecsGet
} from './gaqlchain.js'

const q = 'q'

// replaces util.inspect(str)
const stringify = str => JSON
  .stringify(str, null, '')
  .replace(/'/gi, '')
  .replace(/\\n \+/gi, '')
  .replace(/(:\n*)"([\w.]*)\(\\"/, '$1 $2("')
  .replace(/"([\w.]*)\(\\"/, '$1("')
  .replace(/\\"\)"/, '")')

const gcChainSigArg = (queryName, recarg, recstr, type = typeof recarg) => {
  if (recarg === undefined) {
    recstr = 'undefined'
  } else if (type === 'string') {
    recstr = CHAIN === recarg ? 'row' : `"${recarg}"`
  } else if (Array.isArray(recarg)) {
    if (recarg[0] === ARGSIG) {
      recstr = recarg[3]
    } else if (chainIs(recarg)) {
      recstr = gcChainSigFnArgsFromId(queryName, recarg[1])
        + gcChainSig(recarg)
      // row => ({ friend_id: row('user_sender_id') })
    } else if (chainIsShallow(recarg)) {
      // recstr = '[' + (
      //   recarg.map(arg => gcChainSigArg(arg))
      // ) + ']'
      recstr = recarg.map(arg => gcChainSigArg(queryName, arg))
        .join(', ')
    } else {
      // vanilla flat array
      recstr = stringify(recarg)
    }
  } else if (type === 'object') {
    if (chainIsShallow(recarg)) {
      recstr = Object.keys(recarg).reduce((acc, k) => (
        acc[k] = gcChainSigArg(queryName, recarg[k]),
        acc), {})
      recstr = stringify(recstr)
    } else {
      recstr = stringify(recarg)
    }
  } else {
    recstr = recarg
  }

  return recstr
}

// check for chain shallow
const gcChainSigRec = rec => {
  const queryName = rec[0]
  const queryArgs = rec[1]

  if (queryArgs[0] === ARGSIG) {
    return queryArgs[3]
  }

  const sigArgs = queryArgs
    .map(arg => gcChainSigArg(queryName, arg))
    .join(', ')

  return queryName.includes('.asfn')
    ? `(${sigArgs})`
    : (queryName === BRACKET
      ? `${q}(${sigArgs})`
      : `.${queryName}(${sigArgs})`)
}

// recid ex, '.filter(row => (…))'
// queryName ex, 'filter'
//
// returns 'row => '
const gcChainSigFnArgsFromId = (queryName, recId) => {
  const queryNameCall = `.${queryName}(`

  return recId.startsWith(queryNameCall)
    ? recId.slice(queryNameCall.length, recId.indexOf(' => ') + 4)
    : ''
}

// returns a human readable signature from reqlOb,
//
// ex, '.row("rose")("petal")'
const gcChainSig = chain => {
  if (!chainIs(chain))
    throw new Error('invalid chain')

  return chainRecsGet(chain).reduce((prev, rec) => (
    prev = prev + gcChainSigRec(rec),
    prev.startsWith('.') ? q + prev : prev
  ), '')
}

export default gcChainSig
